import styled from 'styled-components/macro';

export const Container = styled.div`
  margin-top: 17px;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow-y: unset;
  flex: 1;

  .timeWindowTable {
    tbody {
      tr:first-child {
        position: sticky;
        z-index: 2;
        top: -1px;
      }

      tr {
        td.lagDate {
          text-align: left;
          span.badge {
            margin-right: 15px;
          }
        }
      }
    }
  }

  @-moz-document url-prefix() {
    .timeWindowTable {
      tbody {
        tr:first-child {
          border-bottom: 2px solid ${(props) => props.theme.colors.grayLight};
          th:last-child {
            border-right: 2px solid ${(props) => props.theme.colors.grayLight};
          }
        }

        tr:nth-child(2) {
          &:before {
            border-top: 2px solid ${(props) => props.theme.colors.grayLight};
          }
          &:after {
            border-top: 2px solid ${(props) => props.theme.colors.grayLight};
          }
        }

        tr {
          border-right: 0px !important;
          border-inline-end: 2px solid
            ${(props) => props.theme.colors.grayLight};
        }
      }
    }
  }

  table {
    z-index: 0;
    position: relative;

    thead {
      position: sticky;
      top: -1px;
    }
  }
`;

export const Controls = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 10px;
  border: solid 1px #ced4da;
  margin-top: 20px;

  & > * {
    margin-right: 16px;
    margin-bottom: 0;
  }
`;

export const ControlsButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const PanelContainer = styled.div`
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: auto;
  padding-top: 17px;
  margin-bottom: 20px;
  min-height: 500px;
`;

export const PanelTitle = styled.span`
  min-width: 127px;
  height: 33px;
  display: flex;
  align-items: center;
  font-size: 13px;
  color: '#666666';
  font-weight: normal;
  border-bottom: 1px solid #bad9e2;
`;

export const ControlsContainer = styled.div`
  display: flex;
  align-items: center;

  & > * {
    margin-right: 8px;
  }
`;

export const CheckboxWrapper = styled.div`
  margin-top: 10px;
  margin-left: 130px;
`;

export const RadioWrapper = styled.div`
  display: flex;
  align-item: center;
  margin-right: 8px;
`;

export const Label = styled.div`
  margin-left: 5px;
  font-size: 12px;
  color: #333;
  line-height: 14px;
  display: flex;
  align-items: center;
`;

export const HorizontalLabelContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;

  ${Label} {
    margin-left: 0;
    margin-right: -8px;
  }
`;

export const HorizontalContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
`;

// TODO: fix all the nested styles, like tr > td > so on
export const SumRowTDElement = styled.td`
  font-family: Roboto;
  letter-spacing: 0px;
  text-align: ${(props) => (props.align ? props.align : 'left')};
  line-height: 12px !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  border: 1px solid #ced4da !important;
  background-color: #e8edf2 !important;
`;

export const ContainerOutline = styled.div<{ isNew?: boolean }>`
  border: 1px solid #d1d1d1;
  margin: 5px 20px;
  padding: 10px 20px 20px 10px;
  box-sizing: content-box;

  box-shadow: ${(props) => (props.isNew ? '0 0 0 2px #46a2d2' : 'none')};

  background: #ffffff;
  border-radius: 6px;
  position: relative;
`;

export const Header = styled.div`
  flex: 1;
  font-size: 21px;
`;

export const DropdownSpace = styled.div`
  padding: 6.5rem 0;
`;
